// extracted by mini-css-extract-plugin
export var detailNavigationOutercontainer = "styles-module--detailNavigationOutercontainer--f463b";
export var empty = "styles-module--empty--e5bf5";
export var noTopPaddingOnDesktop = "styles-module--noTopPaddingOnDesktop--82b21";